import { useState } from 'react';
import useUpdate from '../../../../hooks/useUpdate';
import Swal from 'sweetalert2';

const ChangePasswordForm = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const {
    updateData,
    isLoading,
    errorMessage,
    successMessage
  } = useUpdate('put');

  const handlePasswordChange = async(e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      alert('New passwords do not match.');
      return;
    }

    // if (newPassword.length < 8) {
    //   alert('Password must be at least 8 characters.');
    //   return;
    // }


      const result = await Swal.fire({
          title: 'Are you sure ?',
          text: 'Do you want to proceed ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'btn-info',
          cancelButtonColor: 'btn-secondary',
          confirmButtonText: 'Yes, proceed!',
          cancelButtonText: 'No, cancel',
          confirmButtonColor: '#03c3ec',
          cancelButtonColor: '#ff3e1d',
      });

      if (result.isConfirmed) {
          try {
              updateData(`${process.env.REACT_APP_API_URL}/change-password/`, {
                  current_password: oldPassword,
                  new_password: newPassword
              }, () => {
                  setOldPassword('');
                  setNewPassword('');
                  setConfirmPassword('');
              });
          } catch (error) {
              console.error("Error inserting data:", error);
          }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          console.log('Submission cancelled.');
      }

  



  };

  return (
    <div className="card mb-4">
      <div className="card-header">
        <h5>Change Password</h5>
        <p className="text-muted">Make sure to use a strong, unique password.</p>
      </div>
      <div className="card-body">
        <form onSubmit={handlePasswordChange}>
          <div className="mb-3">
            <label className="form-label">Old Password</label>
            <input
              type="password"
              className="form-control"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? 'Changing...' : 'Change Password'}
          </button>

          {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
          {successMessage && <div className="text-success mt-3">{successMessage}</div>}
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
